import React, { useState, useEffect, useRef, useMemo } from "react";
import { useLanguage } from "../../hooks/useLanguage";
import { COMPANY_HISTORY_URL } from "../../utils/urls";
import instance from "../../services/services";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Pagination, Navigation } from 'swiper/modules';

function CompanyHistory(){
  const { t } = useLanguage();
  const [companyHistory, setCompanyHistory] = useState([]);
  const [activeKey, setActiveKey] = useState(null);
  const timelineRefs = useRef({});
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const swiperRef = useRef(null);

  useEffect(() => {
    const fetchCompanyHistory = async () => {
        try {
            const response = await instance.post(COMPANY_HISTORY_URL);
            setCompanyHistory(response.data.data);
        } catch (error) {
            console.error('회사 소개 데이터 가져오기 실패', error);
        }
    };
    fetchCompanyHistory();
  }, []);

  const makeKey = (item, index) =>
    `${item.history_year}-${item.history_month}-${index}`;

  const yearAnchors = useMemo(() => {
    const seen = new Set();
    return companyHistory.reduce((acc, item, index) => {
      if (!seen.has(item.history_year)) {
        seen.add(item.history_year);
        acc.push({ year: item.history_year, key: makeKey(item, index) });
      }
      return acc;
    }, []);
  }, [companyHistory]);

  const scrollToHistory = (key) => {
    const node = timelineRefs.current[key];
    if (node) {
      node.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  useEffect(() => {
    if (
      yearAnchors.length &&
      (!activeKey || !yearAnchors.some((item) => item.key === activeKey))
    ) {
      setActiveKey(yearAnchors[0].key);
    }
  }, [yearAnchors, activeKey]);

  const showSwiper = yearAnchors.length > 5;

  return(
    <section className="about_container">
      <h3 className="commu_title noline">{t('company_history')}</h3>
      <p className="intro_desc">세계 최고를 향한 도전과 혁신은 계속됩니다.</p>
      <div className="history_container_wrapper">
        {!showSwiper && (
          <ul className="history_year_box">
              {yearAnchors.map((item) => (
                <li
                  key={item.key}
                  className={`history_year_item${activeKey === item.key ? " active" : ""}`}
                  onClick={() => {
                    setActiveKey(item.key);
                    scrollToHistory(item.key);
                  }}
                >
                  <p>{item.year}</p>
                </li>
              ))}
          </ul>
        )}
        {showSwiper && (
          <div className="history_year_swiper">
            <Swiper
              direction="vertical"
              slidesPerView={5}
              spaceBetween={16}
              pagination={{ clickable: true }}
              modules={[Pagination, Navigation]}
              className="history_year_swiper_inner"
              onBeforeInit={(swiper) => {
                swiper.params.navigation.prevEl = prevRef.current;
                swiper.params.navigation.nextEl = nextRef.current;
              }}
              onSwiper={(swiper) => {
                swiperRef.current = swiper;
                swiper.navigation.init();
                swiper.navigation.update();
              }}
            >
              {yearAnchors.map((item) => (
                <SwiperSlide
                  key={item.key}
                  className={`history_year_slide${activeKey === item.key ? " active" : ""}`}
                  onClick={() => {
                    setActiveKey(item.key);
                    scrollToHistory(item.key);
                  }}
                >
                  <p>{item.year}</p>
                </SwiperSlide>
              ))}
            </Swiper>
            <div className="history_year_swiper_controls">
              <button
                type="button"
                className="history-year-prev"
                ref={prevRef}
                onClick={() => swiperRef.current?.slidePrev()}
                aria-label="Previous years"
              />
              <button
                type="button"
                className="history-year-next"
                ref={nextRef}
                onClick={() => swiperRef.current?.slideNext()}
                aria-label="Next years"
              />
            </div>
          </div>
        )}
        <div className="timeline_section">
          {companyHistory.map((item, index) => (
            <div
              className="time_item"
              key={makeKey(item, index)}
              ref={(el) => {
                timelineRefs.current[makeKey(item, index)] = el;
              }}
            >
              <p className="history_black_txt">
                <span>{item.history_year}.</span>
                <span>{item.history_month}</span></p>
              <span className="line"></span>
              <div className="time_box">
                <div className="text_box">
                  <h4>{item.subject}</h4>
                  <p>{item.contents}</p>
                </div>
                <img
                  src={item.image_path}
                  alt="history1"
                  loading="lazy"
                  // data-aos="fade-up"
                />
              </div>
            </div>
          ))}

        </div>
      </div>
    </section>
  )
};

export default CompanyHistory;
